var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMinus = function SvgIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 3
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.256 2.66q.306 0 .53-.167.222-.166.222-.396V.722q0-.228-.223-.395a.86.86 0 0 0-.53-.167H.76a.86.86 0 0 0-.53.167Q.01.493.009.722v1.375q0 .23.223.396a.86.86 0 0 0 .53.167z"
  })));
};
export default SvgIconMinus;